// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { Options } from './Options.gen';
import type { PublicCustomerControllerGetCustomerProfilesByCustomerIdData } from './PublicCustomerControllerGetCustomerProfilesByCustomerIdData.gen';
import type { PublicCustomerControllerGetCustomerProfilesByCustomerIdErrors } from './PublicCustomerControllerGetCustomerProfilesByCustomerIdErrors.gen';
import type { PublicCustomerControllerGetCustomerProfilesByCustomerIdResponses } from './PublicCustomerControllerGetCustomerProfilesByCustomerIdResponses.gen';

export class PublicCustomerController {
    /**
     * Get customer profiles for the given customer.
     */
    public static getCustomerProfilesByCustomerId<ThrowOnError extends boolean = false>(options: Options<PublicCustomerControllerGetCustomerProfilesByCustomerIdData, ThrowOnError>) {
        return (options.client ?? client).get<PublicCustomerControllerGetCustomerProfilesByCustomerIdResponses, PublicCustomerControllerGetCustomerProfilesByCustomerIdErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/public/customers/{id}/relational-customer-profiles',
            ...options
        });
    }
}
